import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const ExposureIllustration = (props: SVGProps) => {
  const { title = 'ExposureIllustration', className, ...restProps } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      viewBox="0 0 102 98"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
      fill="none"
    >
      <title>{title}</title>
      <path
        d="M50.8371 74.4448C38.321 74.4448 27.9568 64.2667 27.7241 51.7506L27.6194 46.0392C27.5031 39.8626 29.8063 34.0117 34.0869 29.5566C38.3675 25.1131 44.137 22.5889 50.3136 22.4843H50.7557C63.2602 22.4843 73.636 32.6623 73.8686 45.1785L73.9733 50.8898C74.206 63.6386 64.0279 74.2005 51.2791 74.4448H50.8371Z"
        fill="white"
      />
      <path
        d="M50.7442 23.1714C62.8881 23.1714 72.9499 33.0471 73.1709 45.191L73.2756 50.9023C73.5082 63.2789 63.6326 73.5267 51.256 73.7594C51.1164 73.7594 50.9768 73.7594 50.8256 73.7594C38.6817 73.7594 28.62 63.8837 28.399 51.7398L28.2943 46.0285C28.1779 40.0379 30.4113 34.3615 34.564 30.046C38.7166 25.7305 44.3117 23.2877 50.3022 23.183C50.4418 23.183 50.5814 23.183 50.7326 23.183M50.7442 21.7988C50.593 21.7988 50.4418 21.7988 50.2906 21.7988C37.1347 22.0431 26.6774 32.9075 26.9333 46.0517L27.038 51.7631C27.2823 64.7561 37.8907 75.132 50.8373 75.132C50.9885 75.132 51.1397 75.132 51.2909 75.132C64.4352 74.8877 74.9041 64.0233 74.6482 50.8791L74.5435 45.1677C74.2992 32.1747 63.6907 21.7988 50.7442 21.7988Z"
        fill="white"
      />
      <mask
        id="exposure-mask"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="26"
        y="21"
        width="49"
        height="55"
      >
        <path
          d="M27.0385 51.8421C27.2828 64.9864 38.1355 75.4553 51.2914 75.1994C64.4357 74.9551 74.9045 64.0907 74.6486 50.9465L74.5439 45.2351C74.2997 32.0909 63.4353 21.622 50.291 21.8662C37.1351 22.1105 26.6779 32.9749 26.9338 46.1192L27.0385 51.8305V51.8421Z"
          fill="white"
        />
      </mask>
      <g mask="url(#exposure-mask)">
        <path
          d="M29.644 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
        <path
          d="M33.1804 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
        <path
          d="M37.647 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
        <path
          d="M42.1021 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
        <path
          d="M46.5571 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
        <path
          d="M51.012 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
        <path
          d="M55.467 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
        <path
          d="M59.9341 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
        <path
          d="M64.3892 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
        <path
          d="M68.844 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
        <path
          d="M72.3921 48.4699V112.865"
          stroke="black"
          strokeWidth="1.37259"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M26.9331 46.065C26.6889 32.9207 37.1461 22.0563 50.2904 21.8121C63.4347 21.5678 74.299 32.025 74.5433 45.1809C74.7876 58.3252 64.3187 69.1896 51.1861 69.4338C38.0302 69.6781 27.1774 59.2209 26.9331 46.0766V46.065Z"
        fill="currentColor"
      />
      <path
        d="M51.0815 64.5707C61.562 64.373 69.8906 55.7303 69.6929 45.2614C69.4951 34.7926 60.8525 26.464 50.372 26.6501C39.9031 26.8478 31.5745 35.4905 31.7606 45.9594C31.9584 56.4282 40.601 64.7568 51.0699 64.5707H51.0815Z"
        stroke="black"
        strokeWidth="1.37259"
        strokeMiterlimit="10"
      />
      <path
        d="M63.1203 45.3857L50.5926 37.6736L38.344 45.8393L50.8834 53.5514L63.1203 45.3857Z"
        fill="white"
      />
      <path
        d="M31.6204 16.4732C49.3244 5.88796 72.2513 11.6458 82.8365 29.3499C93.4217 47.0423 87.6522 69.9692 69.9481 80.5544C52.2557 91.1279 29.3289 85.37 18.7437 67.6776C8.15847 49.9852 13.9396 27.0584 31.6204 16.4732Z"
        stroke="url(#exposure-gradient-0)"
        strokeWidth="1.01199"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.8"
        d="M91.979 23.8682C105.589 46.6206 98.1789 76.0963 75.4265 89.6942C52.6742 103.304 23.2101 95.8825 9.60053 73.1185C-3.99738 50.3894 3.40063 20.9137 26.153 7.31576C48.9054 -6.29378 78.3811 1.13913 91.9674 23.8799L91.979 23.8682Z"
        stroke="url(#exposure-gradient-1)"
        strokeWidth="1.01199"
        strokeMiterlimit="10"
      />
      <path
        d="M87.714 40.1103C90.7386 38.9251 93.973 37.6783 95.9606 35.8018C98.3679 33.5179 99.7258 31.1724 99.7258 28.6292V16.5804L88.8744 11.3831L76.1589 16.568V28.6416C76.1589 31.1724 77.4305 33.7278 79.8378 35.9993C81.8254 37.8758 84.0228 38.9375 87.0474 40.1226L87.3807 40.2584L87.714 40.1226V40.1103Z"
        fill="black"
        stroke="currentColor"
        strokeWidth="0.827126"
        strokeMiterlimit="10"
      />
      <path
        d="M90.1215 39.6028C93.146 38.4177 95.899 36.7264 97.8866 34.85C100.294 32.5661 101.565 30.023 101.565 27.4922V15.4434L89.7511 10.2831L77.9985 15.4187V27.4922C77.9985 30.023 79.2701 32.5784 81.6774 34.85C83.665 36.7264 86.4179 38.4177 89.4425 39.6028L89.7758 39.7386L90.1091 39.6028H90.1215Z"
        fill="white"
      />
      <path
        d="M86.2817 24.861L89.3433 27.9103L94.8493 21.1575"
        stroke="black"
        strokeWidth="1.45673"
        strokeMiterlimit="10"
      />
      <path
        d="M14.8741 60.0078C14.8741 60.0078 16.8624 57.1712 18.6518 57.6219C20.4413 58.0726 22.92 59.4511 23.7551 60.2332C24.5902 61.0152 25.5181 65.3497 24.1793 65.8667C22.8405 66.3836 23.331 64.6339 23.331 64.6339C23.331 64.6339 22.7875 62.1552 21.5282 61.5189C20.269 60.8827 18.8639 60.5115 18.8639 60.5115C18.8639 60.5115 14.5162 60.3127 14.2113 61.055C13.9065 61.7973 14.8874 60.0078 14.8874 60.0078H14.8741Z"
        fill="black"
        stroke="black"
        strokeWidth="0.546708"
        strokeMiterlimit="10"
      />
      <path
        d="M12.0637 67.5735L14.5955 62.6028C15.4836 60.8663 17.737 60.2168 19.6192 61.1712L20.8917 61.8207C22.774 62.7751 23.5825 64.9755 22.6944 66.7252L20.1627 71.6959"
        stroke="currentColor"
        strokeWidth="0.767718"
        strokeMiterlimit="10"
      />
      <path
        d="M6.9004 65.054L0.516113 77.6001L18.7918 86.9L25.1761 74.3539L6.9004 65.054Z"
        fill="black"
        stroke="currentColor"
        strokeWidth="0.767718"
        strokeMiterlimit="10"
      />
      <path
        d="M13.2965 65.7853L15.8282 60.8145C16.7163 59.0781 18.8637 58.3756 20.6001 59.2637L21.7798 59.8602C23.5163 60.7483 24.2188 62.8956 23.3307 64.632L20.7989 69.6028L22.5751 70.5041L25.1997 65.3611C26.4987 62.7896 25.478 59.6348 22.9065 58.3225L21.1833 57.4477C18.6118 56.1354 15.4571 57.1693 14.1448 59.7409L11.5203 64.8839"
        fill="white"
      />
      <path
        d="M13.2965 65.7853L15.8282 60.8145C16.7163 59.0781 18.8637 58.3756 20.6001 59.2637L21.7798 59.8602C23.5163 60.7483 24.2188 62.8956 23.3307 64.632L20.7989 69.6028L22.5751 70.5041L25.1997 65.3611C26.4987 62.7896 25.478 59.6348 22.9065 58.3225L21.1833 57.4477C18.6118 56.1354 15.4571 57.1693 14.1448 59.7409L11.5203 64.8839"
        stroke="white"
        strokeWidth="0.546708"
        strokeMiterlimit="10"
      />
      <path
        d="M7.78981 62.9835L1.40552 75.5296L19.9412 84.9618L26.3254 72.4157L7.78981 62.9835Z"
        fill="white"
        stroke="white"
        strokeWidth="0.546708"
        strokeMiterlimit="10"
      />
      <path
        d="M13.2304 73.314C13.4424 72.8898 13.9594 72.7175 14.3836 72.9428C14.8077 73.1682 14.98 73.6719 14.7547 74.096L13.6943 76.1904C13.4822 76.6145 12.9652 76.7868 12.5411 76.5615C12.1169 76.3362 11.9446 75.8325 12.1699 75.4083L13.2304 73.314Z"
        fill="black"
      />
      <path
        d="M14.4104 74.6014C15.3547 74.6014 16.1203 73.8359 16.1203 72.8915C16.1203 71.9471 15.3547 71.1816 14.4104 71.1816C13.466 71.1816 12.7004 71.9471 12.7004 72.8915C12.7004 73.8359 13.466 74.6014 14.4104 74.6014Z"
        fill="black"
      />
      <path
        d="M14.1606 55.8221C14.1606 55.8221 15.2773 61.8126 17.3711 65.1743"
        stroke="url(#exposure-gradient-2)"
        strokeWidth="1.01199"
        strokeMiterlimit="10"
      />
      <path
        d="M7.4585 14.1979C7.4585 9.83771 11.0049 6.29126 15.3651 6.29126C19.7252 6.29126 23.2717 9.83771 23.2717 14.1979C23.2717 18.558 19.7252 22.1044 15.3651 22.1044C11.0049 22.1044 7.4585 18.558 7.4585 14.1979Z"
        fill="currentColor"
      />
      <path
        d="M15.3651 20.1086C18.6352 20.1086 21.2759 17.4679 21.2759 14.1978C21.2759 10.9277 18.6352 8.28705 15.3651 8.28705C12.095 8.28705 9.45435 10.9277 9.45435 14.1978C9.45435 17.4679 12.095 20.1086 15.3651 20.1086Z"
        stroke="black"
        strokeWidth="1.03526"
        strokeMiterlimit="10"
      />
      <path
        d="M18.0366 11.527C16.5627 11.527 15.3652 12.7245 15.3652 14.1984C15.3652 15.6722 16.5627 16.8697 18.0366 16.8697V11.527Z"
        fill="black"
      />
      <path
        d="M12.6938 16.8697C14.1677 16.8697 15.3652 15.6722 15.3652 14.1984C15.3652 12.7245 14.1677 11.527 12.6938 11.527V16.8697Z"
        fill="black"
      />
      <path
        d="M75.3386 83.2361C75.3386 78.876 78.8851 75.3295 83.2452 75.3295C87.6054 75.3295 91.1518 78.876 91.1518 83.2361C91.1518 87.5963 87.6054 91.1427 83.2452 91.1427C78.8851 91.1427 75.3386 87.5963 75.3386 83.2361Z"
        fill="currentColor"
      />
      <path
        d="M83.2452 89.1277C86.5153 89.1277 89.156 86.487 89.156 83.2169C89.156 79.9468 86.5153 77.3062 83.2452 77.3062C79.9751 77.3062 77.3345 79.9468 77.3345 83.2169C77.3345 86.487 79.9751 89.1277 83.2452 89.1277Z"
        stroke="black"
        strokeWidth="1.03526"
        strokeMiterlimit="10"
      />
      <path
        d="M83.2454 80.5182L84.1052 82.2684L86.0242 82.5447L84.6425 83.8958L84.9649 85.7995L83.2454 84.8937L81.5413 85.7995L81.8637 83.8958L80.4819 82.5447L82.401 82.2684L83.2454 80.5182Z"
        fill="black"
      />
      <path
        d="M28.5261 37.0226C31.9111 28.2752 40.3327 21.9939 50.3014 21.8078"
        stroke="white"
        strokeWidth="1.11668"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id="exposure-gradient-0"
          x1="17.5179"
          y1="30.6808"
          x2="84.3208"
          y2="66.2681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="#10192F" />
        </linearGradient>
        <linearGradient
          id="exposure-gradient-1"
          x1="73.7079"
          y1="5.76259"
          x2="28.0855"
          y2="91.3812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="#10192F" />
        </linearGradient>
        <linearGradient
          id="exposure-gradient-2"
          x1="13.6605"
          y1="60.5912"
          x2="17.8015"
          y2="60.5912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4D73DB" />
          <stop offset="1" stopColor="#4568C6" />
        </linearGradient>
      </defs>
    </svg>
  );
};
